'use strict';
import {module} from '../app';

module.directive('customIframe', function () {
  let linkFn = function (scope, element, attrs) {
    element.find('iframe.frame').on('load', function (event) {
      scope.onLoad();
    });
  };
  return {
    restrict: 'EA',
    scope: {
      src: '=',
      onLoad: '='
    },
    template: '<iframe class="frame" frameborder="0" border="0" marginwidth="0" marginheight="0" scroll="auto" ng-src="{{src}}"></iframe>',
    link: linkFn
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/customIframe.js